'use strict';

export function UsersService($resource) {
  return $resource('/api/users/:id', {
    id: '@_id'
  }, {
    update: {
      method: 'PUT',
      params: {
        id: '@_id'
      },
    }
  });
}

export default angular.module('fplTruescapeComApp.Users', [])
  .factory('Users', UsersService)
  .name;



// WEBPACK FOOTER //
// ./client/components/Users/Users.service.js